import SharedRiskTab from 'pages/mobile/Finance/shared/RiskTab';
import React from 'react';

import { useFactoringOperationDetail } from '../context';

export interface RiskProps {
  requestId: string;
}

const Risk: React.FC<RiskProps> = () => {
  const { quoteId, requestId } = useFactoringOperationDetail();
  return (
    <SharedRiskTab
      product="factoring"
      requestId={requestId}
      quoteId={quoteId}
    />
  );
};

export default Risk;
